/**
 * A Stimulus controller that renders markdown content in real-time.
 * @module MarkdownController
 *
 * This controller watches an input element specified by a CSS selector
 * and renders its markdown content into its own element.
 *
 * @example
 * HTML structure:
 * <textarea id="my-textarea">Aaa **bold Bbb** Ccc</textarea>
 * <div data-controller="markdown" data-markdown-source-value="#my-textarea"></div>
 */
import { Controller } from '@hotwired/stimulus';
import { marked } from 'marked';

export default class extends Controller {
  static values = {
    source: String
  }

  connect() {
    this.sourceElement = document.querySelector(this.sourceValue);
    if (!this.sourceElement) {
      return;
    }

    this.sourceElement.addEventListener('input', this.render.bind(this));
    if (this.sourceElement.value) {
      this.render();
    }
  }

  disconnect() {
    if (this.sourceElement) {
      this.sourceElement.removeEventListener('input', this.render.bind(this));
    }
  }

  render() {
    const markdown = this.sourceElement.value;
    this.element.innerHTML = marked.parse(markdown);
  }
}
